import { render } from "./LightGallery.vue?vue&type=template&id=7b210c50&scoped=true"
import script from "./LightGallery.vue?vue&type=script&lang=js"
export * from "./LightGallery.vue?vue&type=script&lang=js"

import "./LightGallery.vue?vue&type=style&index=0&id=7b210c50&lang=css"
import "./LightGallery.vue?vue&type=style&index=1&id=7b210c50&lang=scss&scoped=true"

import exportComponent from "/home/controlcenter/sourcecode/dubiverse/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b210c50"]])

export default __exports__